export interface CustomField {
  id: number;
  name?: string;
  fieldType?: FieldType;
  label?: string;
  requiredFlag?: boolean;
  companyName?: string;
  defaultValue?: string;
  selectValues?: string;
}

export enum FieldType {
  Input = 'input',
  Select = 'select',
  Checkbox = 'checkbox'
}
